if ( typeof ProductVariants !== 'function' ) {

	class ProductVariants extends HTMLElement {

		constructor() {
			super();
			this.init();
		}

		init() {

			this.price = document.querySelector(`#product-price-${this.dataset.id}`);

			if ( this.price ) {
				this.priceOriginal = this.price.querySelector('[data-js-product-price-original]');
				this.priceCompare = this.price.querySelector('[data-js-product-price-compare]');
				this.priceUnit = this.price.querySelector('[data-js-product-price-unit]');
			}

			this.productForm = document.querySelector(`#product-form-${this.dataset.id}`);
			if ( this.productForm ) {
				this.productQty = this.productForm.querySelector('[data-js-product-quantity]');
				this.addToCarts = this.productForm.querySelectorAll('[data-js-product-add-to-cart]');
				this.addToCartText = this.productForm.querySelector('[data-js-product-add-to-cart-text]');
			}

			this.addEventListener('change', this.onVariantChange);
			let initVariantChange = false;

			if ( this.hasAttribute('data-variant-required' ) ) {
				this.variantRequired = true;
				this.noVariantSelectedYet = true;
				if ( document.location.search.includes('variant') ) {
					const initVariant = parseInt(new URLSearchParams(document.location.search).get('variant'));
					this.currentVariant = this.getVariantData().find((variant) => {
						if ( variant.id == initVariant ) {
							variant.options.map((option, index) => {
								const variantContainer = this.querySelectorAll(`[data-js-product-variant]`)[index].querySelector(`[data-js-product-variant-container]`);
								if ( variantContainer.dataset.jsProductVariantContainer == 'radio' ) {
									variantContainer.querySelector(`input[value="${option}"]`).checked = true;
								} else if ( variantContainer.dataset.jsProductVariantContainer == 'select' ) {
									variantContainer.value = option;
								}
							})
							return variant;
						}
					});

					if ( this.currentVariant ) {
						this.variantRequired = false;
						this.noVariantSelectedYet = false;
						initVariantChange = true;
					}

				}

			} else {
				this.variantRequired = false;
				this.noVariantSelectedYet = false;
			}

			this.updateOptions();
			this.updateMasterId();
			this.updateUnavailableVariants();

			this.productStock = document.querySelector(`#product-${this.dataset.id} [data-js-variant-quantity]`);
			this.productStockProgress = document.querySelector(`#product-${this.dataset.id} [data-js-variant-quantity-progress]`);
			if ( this.productStock && document.querySelector(`#product-${this.dataset.id} [data-js-variant-quantity-data]`) ) {
				this.productStockData = JSON.parse(document.querySelector(`#product-${this.dataset.id} [data-js-variant-quantity-data]`).dataset.inventory);
			}
			this.updateStock();

			this._event = new Event('VARIANT_CHANGE');

			if ( initVariantChange ) {
				this.onVariantChange();
			}

		}

		onVariantChange(){

			this.updateOptions();
			this.updateMasterId();
			this.updateVariantInput();
			if ( this.price ) {
				this.updatePrice();
			}
			this.updateStock();
			this.updateUnavailableVariants();
			this.updatePickupAvailability();
			if ( ! this.hasAttribute('data-no-history') ) {
				this.updateURL();
			}
			this.updateDetails();

			if ( this.productForm ) {
				if ( ! this.currentVariant || ! this.currentVariant.available ) {
					if ( this.productQty ) this.productQty.style.display = 'none';
					this.addToCarts.forEach(btn => btn.classList.add('disabled'));
					this.productForm.classList.add('disabled-cart');
					this.addToCartText.textContent = KROWN.settings.locales.products_sold_out_variant;
				} else {
					if ( this.productQty ) this.productQty.style.display = '';
					this.addToCarts.forEach(btn => btn.classList.remove('disabled'));
					this.productForm.classList.remove('disabled-cart');
					this.addToCartText.textContent = this.hasAttribute('data-show-bundle-wording') ? KROWN.settings.locales.products_add_to_bundle_button : this.addToCartText.hasAttribute('data-show-preorder-wording') ? KROWN.settings.locales.products_preorder_button : KROWN.settings.locales.products_add_to_cart_button;
				}
				if ( ! this.currentVariant ) {
					this.productForm.classList.add('unavailable-variant');
					this.addToCartText.textContent = (this.variantRequired && this.noVariantSelectedYet) ? KROWN.settings.locales.products_variant_required : KROWN.settings.locales.products_unavailable_variant;
				} else {
					this.productForm.classList.remove('unavailable-variant');
				}
			}
			this.dispatchEvent(this._event);

		}

		updateOptions(){

			this.options = [];

			this.querySelectorAll('[data-js-product-variant-container]').forEach(elm=>{
				if ( elm.dataset.jsProductVariantContainer == 'radio' ) {
					elm.querySelectorAll('.product-variant__input').forEach(el=>{
						if ( el.checked ) {
							this.options.push(el.value);
						}
					});
				} else {
					if ( ! ( this.variantRequired && elm.selectedIndex == 0 ) ) {
						this.options.push(elm.value);
					}
				}
			});

			if ( this.variantRequired && this.noVariantSelectedYet && this.options.length >= parseInt(this.dataset.variants) ) {
				this.noVariantSelectedYet = false;
			}

		}

		updateMasterId(){
			this.currentVariant = this.getVariantData().find((variant) => {
				return !variant.options.map((option, index) => {
					return this.options[index] === option;
				}).includes(false);
			});
		}

		updatePrice(){
			if (!this.currentVariant) {
				if ( ! ( this.variantRequired && this.noVariantSelectedYet ) ) {
					this.priceOriginal.innerHTML = '';
					this.priceCompare.innerHTML = '';
					this.priceUnit.innerHTML = '';
				}
			} else {
				this.priceOriginal.innerHTML = this._formatMoney(this.currentVariant.price, KROWN.settings.shop_money_format);
				if ( this.currentVariant.compare_at_price > this.currentVariant.price ) {
					this.priceCompare.innerHTML = this._formatMoney(this.currentVariant.compare_at_price, KROWN.settings.shop_money_format);
				} else {
					this.priceCompare.innerHTML = '';
				}

				if ( this.currentVariant.unit_price_measurement ) {
					this.priceUnit.innerHTML = `
						${this._formatMoney(this.currentVariant.unit_price, KROWN.settings.shop_money_format)} / 
						${( this.currentVariant.unit_price_measurement.reference_value != 1 ? this.currentVariant.unit_price_measurement.reference_value + ' ' : '' )}
						${this.currentVariant.unit_price_measurement.reference_unit}
					`;
				} else {
					this.priceUnit.innerHTML = '';
				}
			}
		
		}

		updateStock(){

			if (!this.currentVariant) {
				if ( this.productStock ) {
					this.productStock.innerHTML = '';
				}
			} else {
				if ( this.productStock && this.productStockData ) {

					let currentVariant = false;
					for ( const variant of this.productStockData ) {
						if ( variant.id == this.currentVariant.id ) {
							currentVariant = variant;
							break;
						}
					}
					this.productStock.innerHTML = '';

					if ( currentVariant ) {

						if ( currentVariant.quantity <= 0 ) {
							if ( currentVariant.inventory == 'continue' ) {
								this.productStock.innerHTML = KROWN.settings.locales.products_preorder;
								this.productStock.setAttribute('data-stock', 'pre-order');
							} else if ( currentVariant.inventory == 'deny' ) {
								this.productStock.innerHTML = KROWN.settings.locales.products_no_products;
								this.productStock.setAttribute('data-stock', 'out-of-stock');
							}
						} else if ( currentVariant.quantity == '1' ) {
							this.productStock.innerHTML = KROWN.settings.locales.products_one_product;
							this.productStock.setAttribute('data-stock', 'one-item-stock');
						} else if ( currentVariant.quantity <= parseInt(this.productStock.dataset.lowStock) ) {
							this.productStock.innerHTML = KROWN.settings.locales.products_few_products.replace('{{ count }}', currentVariant.quantity);
							this.productStock.setAttribute('data-stock', 'little-stock');
						} else if ( currentVariant.unavailable ) {
							this.productStock.innerHTML = KROWN.settings.locales.products_no_products;
							this.productStock.setAttribute('data-stock', 'out-of-stock');
						} else if ( currentVariant.quantity > parseInt(this.productStock.dataset.lowStock) && this.productStock.dataset.type == "always" ) {
							this.productStock.innerHTML = KROWN.settings.locales.products_many_products.replace('{{ count }}', currentVariant.quantity);
							this.productStock.setAttribute('data-stock', 'in-stock');
						} else if ( ! currentVariant.quantity && this.productStock.dataset.type == "always" )  {
							this.productStock.innerHTML = KROWN.settings.locales.products_enough_products;
							this.productStock.setAttribute('data-stock', 'in-stock');
						}

						if ( this.productStockProgress ) {
							let progressQty = 0;
							if ( currentVariant.quantity <= 0 && currentVariant.inventory == 'continue' || typeof currentVariant.quantity === 'undefined' ) {
								progressQty = parseInt(this.productStock.dataset.highStock);
							} else if ( currentVariant.quantity > 0 ) {
								progressQty = currentVariant.quantity;
							}
							if ( progressQty >= parseInt(this.productStock.dataset.highStock)  ) {
								this.productStockProgress.style.width = `100%`;
							} else {
								this.productStockProgress.style.width = `${100 * progressQty / parseInt(this.productStock.dataset.highStock)}%`;
							}
						}

					}
				}
			}
		}

		updateDetails(){

			document.querySelectorAll(`#product-${this.dataset.id} [data-js-product-sku]`).forEach(elm=>{
				if ( this.currentVariant && this.currentVariant.sku ) {
					elm.innerHTML = KROWN.settings.locales.product_sku + this.currentVariant.sku;
				} else {
					elm.innerHTML = '';
				}
			});

			document.querySelectorAll(`#product-${this.dataset.id} [data-js-product-barcode]`).forEach(elm=>{
				if ( this.currentVariant && this.currentVariant.barcode ) {
					elm.innerHTML = KROWN.settings.locales.product_barcode + this.currentVariant.barcode;
				} else {
					elm.innerHTML = '';
				}
			});
			
		}

		updatePickupAvailability() {
			const pickUpAvailability = document.querySelector('pickup-availability');
			if (!pickUpAvailability) return;

			if (this.currentVariant && this.currentVariant.available) {
				pickUpAvailability.fetchAvailability(this.currentVariant.id);
			} else {
				pickUpAvailability.removeAttribute('available');
				pickUpAvailability.innerHTML = '';
			}
		}

		updateUnavailableVariants(){

			if ( this.dataset.hideVariants != 'false' ) {

				let options1 = {},
						options2 = {},
						options3 = {},

						option1Selected = null,
						option2Selected = null;

				if ( this.dataset.variants > 1 ) {
					option1Selected = this._getSelectedOption(0);
					this._resetDisabledOption(1);
				}
				if ( this.dataset.variants > 2 ) {
					option2Selected = this._getSelectedOption(1);
					this._resetDisabledOption(2);
				}

				this.getVariantData().forEach((el) => {
					if ( this.dataset.variants > 0 ) {
						if ( ! options1[el.option1] ) {
							options1[el.option1] = [];
						}
						options1[el.option1].push(String(el.available));
					}
					if ( this.dataset.variants > 1 ) {
						if ( ! options2[el.option2] ) {
							options2[el.option2] = [];
						}
						options2[el.option2].push(String(el.available));
					}
					if ( this.dataset.variants == 2 ) {
						if ( el.option1 == option1Selected && ! el.available ) {
							this._setDisabledOption(1, el.option2);
						}
					}
					if ( this.dataset.variants > 2 ) {
						if ( ! options3[el.option3] ) {
							options3[el.option3] = [];
						}
						options3[el.option3].push(String(el.available));
						if ( el.option2 == option2Selected && el.option1 == option1Selected && ! el.available ) {
							this._setDisabledOption(2, el.option3);
						}
					}

				});

				if ( this.dataset.variants > 0 ) {
					Object.keys(options1).forEach((key)=>{
						if ( ! options1[key].includes('true') ){
							this._setDisabledOption(0, key);
						}
					});
				}
				if ( this.dataset.variants > 1 ) {
					Object.keys(options2).forEach((key)=>{
						if ( ! options2[key].includes('true') ){
							this._setDisabledOption(1, key);
						}
					});
				}
				if ( this.dataset.variants > 2 ) {
					Object.keys(options3).forEach((key)=>{
						if ( ! options3[key].includes('true') ){
							this._setDisabledOption(2, key);
						}
					});
					Object.keys(options2).forEach((key)=>{
						if ( ! options2[key].includes('true') ){
							if ( option2Selected == key ) {
								if ( this.dataset.hideVariants == 'disable' ) {
									this.querySelectorAll('[data-js-product-variant]')[2].querySelector('.product-variant-value').setAttribute('disabled', 'disabled');
								} else {
									this.querySelectorAll('[data-js-product-variant]')[2].querySelector('.product-variant-value').classList.add('disabled');
								}
							}
						}
					});
				}

			}
		}

		_getSelectedOption(i){
			let selectedOption = null;
			this.querySelectorAll('[data-js-product-variant]')[i].querySelectorAll('[data-js-product-variant-container]').forEach(elm=>{
				if ( elm.dataset.jsProductVariantContainer == 'radio' ) {
					elm.querySelectorAll('.product-variant__input').forEach(el=>{
						if ( el.checked ) {
							selectedOption = el.value;
						}
					});
				} else {
					selectedOption = elm.value;
				}
			});
			return selectedOption;
		}

		_resetDisabledOption(i){
			this.querySelectorAll('[data-js-product-variant]')[i].querySelectorAll('.product-variant-value').forEach((elm)=>{
				elm.classList.remove('disabled');
				elm.classList.remove('hide-variant')
				if ( ! elm.hasAttribute('default') ) {
					elm.removeAttribute('disabled');
				}
				elm.parentNode.classList.remove('hide-variant');
			})
		}

		_setDisabledOption(i,option){
			let variant = this.querySelectorAll('[data-js-product-variant]')[i].querySelector(`.product-variant-value[value="${option.replace('"', '&x22;')}"]`);
			if ( variant ) {
				if ( this.dataset.hideVariants == 'disable' ) {
					variant.setAttribute('disabled', 'disabled');
				} else if ( this.dataset.hideVariants == 'true' ) {
					variant.classList.add('disabled');
				} else if ( this.dataset.hideVariants == 'hide' ) {
					if ( this.querySelectorAll('[data-js-product-variant]')[i].querySelector('[data-js-product-variant-container]').dataset.jsProductVariantContainer == 'radio' ) {
						variant.parentNode.classList.add('hide-variant');
					} else {
						variant.classList.add('hide-variant');
					}
				}
			}
		}

		updateURL(){
			if (!this.currentVariant) return;
			window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
		}

		updateVariantInput() {
			if (!this.currentVariant) return;
			const productForms = document.querySelectorAll(`#product-form-${this.dataset.id}, #product-form-installment`);
			productForms.forEach((productForm) => {
				const input = productForm.querySelector('input[name="id"]');
				input.value = this.currentVariant.id;
				input.dispatchEvent(new Event('change', { bubbles: true }));
			});
		}

		getVariantData() {
			this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
			return this.variantData;
		}

		_formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

	}

  if ( typeof customElements.get('product-variants') == 'undefined' ) {
		customElements.define('product-variants', ProductVariants);
	}
	window.ProductVariants = ProductVariants;

}

/* ---
	Product Form
--- */

if ( typeof ProductForm !== 'function' ) {

	class ProductForm extends HTMLElement {
		constructor() {
			super();   
			this.init();
		}

		init(){
			this.cartType = this.hasAttribute('data-ajax-cart') ? 'ajax' : 'page';
			if ( ! document.body.classList.contains('template-cart') || this.hasAttribute('data-force-form' ) ) {
				this.form = this.querySelector('form');
				this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
				this.ADD_TO_CART = new Event('add-to-cart');
			}
			if ( document.body.classList.contains('touchevents') ) {
				const submitButton = this.querySelector('[type="submit"]');
				if ( submitButton ) {
					submitButton.addEventListener('touchend', e=>{
						//submitButton.click();
					});
				}
			}
		}

    // Sepete Ekleme Eski Kodu
		
		// onSubmitHandler(e) {	
		// 	e.preventDefault();
			
		// 	const submitButtons = this.querySelectorAll('[type="submit"]');

		// 	submitButtons.forEach(btn => btn.classList.add('working'));

		// 	const body = this._serializeForm(this.form);
		// 	let alert = '';

		// 	fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
		// 		body,
		// 		headers: {
		// 			'Content-Type': 'application/x-www-form-urlencoded',
		// 			'X-Requested-With': 'XMLHttpRequest'
		// 		},
		// 		method: 'POST'
		// 	})
		// 		.then(response => response.json())
		// 		.then(response => {
		// 			const popover = document.getElementById('addedtocartpopover')
		// 			const { image, title, price } = response
		// 			const splittedBody = body.split('quantity=')
		// 			const qty = splittedBody.length > 1
		// 				? Number(splittedBody[1][0])
		// 				: 1
		// 			popover.querySelector('[data-title]').innerText = title
		// 			popover.querySelector('[data-price]').innerText = ProductVariants.prototype._formatMoney(qty * price, KROWN.settings.shop_money_format);
		// 			qty > 1
		// 				? popover.querySelector('[data-qty]').innerText = qty + ' * '
		// 				: popover.querySelector('[data-qty]').innerText = ''
		// 			let _img = popover.querySelector('img');
		// 			const failureIcon = popover.querySelector('.icon-red-check');
		// 			const successIcon = popover.querySelector('.icon-green-check');
		// 			const successMessage = popover.querySelector('.success-message');
		// 			const failureMessage = popover.querySelector('.failure-message');
					
		// 			if ( response.status == 422 ) {
		// 				// wrong stock alert

		// 				// Show failure message and red-check icon
		// 				failureIcon.classList.remove('hidden');
		// 				successIcon.classList.add('hidden');
		// 				failureMessage.classList.remove('hidden');
		// 				successMessage.classList.add('hidden');
		// 				_img.classList.add("hidden");
		// 				popover.querySelector('[data-title]').innerText = "Not enough stock"
		// 				popover.querySelector('[data-price]').classList.add("hidden")
		// 				popover.querySelector('[data-qty]').classList.add("hidden")
		// 				popover.querySelector('[data-go-to-basket]').classList.add("hidden")
		// 				popover.showModal();		
						
		// 				//Other logic stuff
		// 				alert = document.createElement('span');
		// 				alert.className = 'alert alert--error';
		// 				if ( typeof response.description === 'string' ) {
		// 					alert.innerHTML = response.description;
		// 				} else {
		// 					alert.innerHTML = response.message;
		// 				}
		// 				if ( this.cartType == 'page' ) {
		// 					if ( document.getElementById('product-page-form-error-cart-alert') ) {
		// 						document.getElementById('product-page-form-error-cart-alert').remove();
		// 					}
		// 					alert.style.marginTop = '1em';
		// 					alert.style.marginBottom = '0';
		// 					alert.id = 'product-page-form-error-cart-alert';
		// 					this.form.parentElement.append(alert);
		// 					return false;
		// 				}
		// 				return fetch('?section_id=helper-cart');
		// 			} else {
		// 				// Show success message and green-check icon
		// 				successIcon.classList.remove('hidden');
		// 				failureIcon.classList.add('hidden');
		// 				successMessage.classList.remove('hidden');
		// 				failureMessage.classList.add('hidden');
		// 				_img.classList.remove("hidden");

		// 				popover.querySelector('[data-price]').classList.remove("hidden")
		// 				popover.querySelector('[data-qty]').classList.remove("hidden")
		// 				popover.querySelector('[data-go-to-basket]').classList.remove("hidden")

		// 				if ( this.cartType == 'ajax' ) {
		// 					successIcon.classList.remove('hidden');
		// 					let newImg = new Image;
		// 					if(image){
		// 						newImg.onload = function() {
		// 							_img.src = this.src;
		// 							popover.showModal()
		// 						}
		// 						newImg.src = image + '&width=100';
		// 					} else {
		// 						_img.src = '';
		// 						popover.showModal()
		// 					}
		// 				} 
		// 				return fetch('?section_id=helper-cart');
		// 			}
		// 		})
		// 		.then(response =>response.text())
		// 		.then(text => {
		// 			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
		// 			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
		// 			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

		// 			if(this.cartType == 'page'){
		// 				const cartItems = document.getElementById('AjaxCartForm');
		// 				cartItems.innerHTML = cartFormInnerHTML;
		// 				cartItems.ajaxifyCartItems();

		// 				if ( alert != '' ) {
		// 					document.getElementById('AjaxCartForm').querySelector('form').prepend(alert);
		// 				}
	
		// 				document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
		// 			}


		// 			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
		// 				elm.textContent = sectionInnerHTML.querySelector('[data-cart-count]').textContent;
		// 			});
		// 			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
		// 				elm.textContent = sectionInnerHTML.querySelector('[data-cart-total]').textContent;
		// 			});
		// 			this.dispatchEvent(this.ADD_TO_CART);

		// 			// a11y
		// 			if ( document.getElementById('screen-reader-info') ) {
		// 				document.getElementById('screen-reader-info').innerText = `${KROWN.settings.locales.cart_announcement}`;
		// 				setTimeout(()=>{
		// 					document.getElementById('screen-reader-info').innerText = '';
		// 				}, 1000);
		// 			}

		// 		})
		// 		.catch(e => {
		// 			console.log(e);
		// 		})
		// 		.finally(() => {
		// 			submitButtons.forEach(btn => btn.classList.remove('working'));
		// 		});
		// }


		// Sepete Ekleme Yeni Kodu Free-Product İle
		onSubmitHandler(e) {	
			e.preventDefault();
			
			const submitButtons = this.querySelectorAll('[type="submit"]');
			const maxPurchase = submitButtons[0].dataset.maxPurchase;
			
			if (!maxPurchase) {
				// If no max purchase limit, proceed with normal add to cart
				this.processAddToCart(submitButtons);
				return;
			}

			// Get quantity user is trying to add
			const quantityInput = this.querySelector('[name="quantity"]');
			const quantityToAdd = quantityInput ? parseInt(quantityInput.value, 10) : 1;
			const variantId = this.querySelector('[name="id"]').value;

			// Check current cart contents first
			fetch(`${KROWN.settings.routes.cart_url}.js`)
				.then(response => response.json())
				.then(cart => {
					// Find if this variant already exists in cart
					const existingItem = cart.items.find(item => item.variant_id === parseInt(variantId));
					const currentQuantity = existingItem ? existingItem.quantity : 0;
					const maxAllowed = parseInt(maxPurchase);

					// Calculate how many more can be added
					const remainingAllowed = maxAllowed - currentQuantity;

					if (remainingAllowed <= 0) {
						// Already at max limit
						this.showMaxPurchaseError(maxAllowed, true);
					} else if (quantityToAdd > remainingAllowed) {
						// Trying to add too many
						this.showMaxPurchaseError(maxAllowed, false, remainingAllowed);
					} else {
						// OK to add
						this.processAddToCart(submitButtons);
					}
				})
				.catch(error => {
					console.error('Error checking cart:', error);
					// Proceed with normal add to cart if cart check fails
					this.processAddToCart(submitButtons);
				});
		}

		showMaxPurchaseError(maxAllowed, isAtLimit, remainingAllowed = 0) {
			const isMobile = window.innerWidth < 768;
			const currentUrl = window.location.pathname;
			
			let errorMessage;
			if (currentUrl.includes('/en/')) {
				errorMessage = `Maximum order limit for this product is ${maxAllowed} units.`;
			} else {
				errorMessage = `Voor dit product geldt een maximale bestelgrens van ${maxAllowed} stuks.`;
			}

			if (isMobile) {
				// Mobile error 
				const popover = document.getElementById('addedtocartpopover');
				const successLayout = popover.querySelector('.success-layout');
				const errorLayout = popover.querySelector('.error-layout');
				
				// Update error layout content
				errorLayout.querySelector('.failure-message').textContent = errorMessage;
				
				// For product listing page
				const quickAddContainer = this.form.closest('[data-product-title]');
				if (quickAddContainer) {
					errorLayout.querySelector('[data-error-title]').textContent = quickAddContainer.dataset.productTitle;
					errorLayout.querySelector('[data-error-price]').textContent = quickAddContainer.dataset.productPrice;
					if (quickAddContainer.dataset.productImage) {
						errorLayout.querySelector('img').src = quickAddContainer.dataset.productImage;
					}
				}
				// Don't update title and price for product detail page - they're already set in the HTML
				
				successLayout.classList.add('hidden');
				errorLayout.classList.remove('hidden');
				
				popover.showModal();
			} else {
				const alertBox = document.createElement('div');
				alertBox.className = 'bg-[#FFF3CD] p-3 rounded-md flex gap-2 items-start mt-4 transition-opacity duration-300 opacity-0';
				alertBox.innerHTML = `
					<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M5.54118 9.17433C7.48676 5.72478 8.45954 4 10 4C11.5405 4 12.5133 5.72477 14.4589 9.17432L14.7013 9.60418C16.3181 12.4707 17.1265 13.904 16.3959 14.952C15.6653 16 13.8577 16 10.2425 16H9.7576C6.14241 16 4.33482 16 3.60421 14.952C2.8736 13.904 3.68198 12.4707 5.29874 9.60418L5.54118 9.17433Z" stroke="#D85600" stroke-width="1.5"/>
						<path d="M10 7.33325V10.6666" stroke="#D85600" stroke-width="1.5" stroke-linecap="round"/>
						<circle cx="10" cy="12.6667" r="0.666667" fill="#D85600"/>
					</svg>
					<p class="text-sm">${errorMessage}</p>
				`;

				const existingAlert = this.form.querySelector('.bg-\\[\\#FFF3CD\\]');
				if (existingAlert) {
					existingAlert.remove();
				}

				this.form.appendChild(alertBox);

				requestAnimationFrame(() => {
					alertBox.style.opacity = '1';
				});

				setTimeout(() => {
					alertBox.style.opacity = '0';
					setTimeout(() => {
						alertBox.remove();
					}, 300);
				}, 3000);
			}
		}

		processAddToCart(submitButtons) {
			submitButtons.forEach(btn => btn.classList.add('working'));
		
			const body = this._serializeForm(this.form);
			let alert = '';
			let freeProductAdded = false;
			/* ========== BXGY GIFT START ========== */
			const bxgyGiftMeta = this._getBxgyGiftMeta(submitButtons);
			let bxgyPendingShowSuccessModal = null;
			/* ========== BXGY GIFT END ========== */

			const isFreeProduct = this.form.dataset.price == 0;
			if(isFreeProduct){
				this.showFreeProductErrorDialog();
				submitButtons.forEach(btn => btn.classList.remove('working'));
				return
			};
		
			fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
				body,
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'X-Requested-With': 'XMLHttpRequest'
				},
				method: 'POST'
			})
			.then(response => response.json())
			.then(response => {
				const popover = document.getElementById('addedtocartpopover')
				const { image, title, price } = response
				const splittedBody = body.split('quantity=')
				const qty = splittedBody.length > 1
				? Number(splittedBody[1][0])
				: 1
				popover.querySelector('[data-title]').innerText = title
				popover.querySelector('[data-price]').innerText = ProductVariants.prototype._formatMoney(qty * price, KROWN.settings.shop_money_format);
				qty > 1
					? popover.querySelector('[data-qty]').innerText = qty + ' * '
					: popover.querySelector('[data-qty]').innerText = ''
				let _img = popover.querySelector('img');
				const failureIcon = popover.querySelector('.icon-red-check');
				const successIcon = popover.querySelector('.icon-green-check');
				const successMessage = popover.querySelector('.success-message');
				const failureMessage = popover.querySelector('.failure-message');
		
				if ( response.status == 422 ) {
					// wrong stock alert

					// Show failure message and red-check icon
					failureIcon.classList.remove('hidden');
					successIcon.classList.add('hidden');
					failureMessage.classList.remove('hidden');
					successMessage.classList.add('hidden');
					_img.classList.add("hidden");
					popover.querySelector('[data-title]').innerText = "Not enough stock"
					popover.querySelector('[data-price]').classList.add("hidden")
					popover.querySelector('[data-qty]').classList.add("hidden")
					popover.querySelector('[data-go-to-basket]').classList.add("hidden")
					popover.showModal();	

						//Other logic stuff
						alert = document.createElement('span');
						alert.className = 'alert alert--error';
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
						if ( this.cartType == 'page' ) {
							if ( document.getElementById('product-page-form-error-cart-alert') ) {
								document.getElementById('product-page-form-error-cart-alert').remove();
							}
							alert.style.marginTop = '1em';
							alert.style.marginBottom = '0';
							alert.id = 'product-page-form-error-cart-alert';
							this.form.parentElement.append(alert);
							return false;
						}
						return fetch('?section_id=helper-cart');
				} else {
					// Show success message and green-check icon
					successIcon.classList.remove('hidden');
					failureIcon.classList.add('hidden');
					successMessage.classList.remove('hidden');
					failureMessage.classList.add('hidden');
					_img.classList.remove("hidden");

					popover.querySelector('[data-price]').classList.remove("hidden")
					popover.querySelector('[data-qty]').classList.remove("hidden")
					popover.querySelector('[data-go-to-basket]').classList.remove("hidden")
		
					/* ========== BXGY GIFT START ========== */
					// Hediye stok uyarısı (varsa) önce gösterilsin, sonra "sepete eklendi" popover'ı açılsın.
					// Bu yüzden showModal() burada hemen çağrılmıyor; bxgyPendingShowSuccessModal'a
					// saklanıp zincirin sonunda (gift add + helper-cart refresh tamamlandıktan sonra) çalıştırılıyor.
					if ( this.cartType == 'ajax' ) {
						successIcon.classList.remove('hidden');
						bxgyPendingShowSuccessModal = () => {
							const showAddedToCart = () => {
								let newImg = new Image;
								if(image){
									newImg.onload = function() {
										_img.src = this.src;
										popover.showModal()
									}
									newImg.src = image + '&width=100';
								} else {
									_img.src = '';
									popover.showModal()
								}
							};
							if (window.KaracaBxgy) {
								window.KaracaBxgy.flushPendingWarningBefore(showAddedToCart);
							} else {
								showAddedToCart();
							}
						};
					}
					/* ========== BXGY GIFT END ========== */
					return fetch(`/products/${response.handle}.js`)
						.then(productResponse => productResponse.json())
						.then(productData => {
							if (productData.tags) {
								productData.tags.forEach(tag => {
									if (tag.startsWith('free-product_')) {
										const freeProductVariantId = tag.replace('free-product_', '');
										this.addFreeProductToCart(freeProductVariantId);
										freeProductAdded = true;
									}
								});
							}
							/* ========== BXGY GIFT START ========== */
							if (bxgyGiftMeta.giftVariantId && window.KaracaBxgy) {
								const qtyMatch = body.match(/quantity=(\d+)/);
								const addedQty = qtyMatch ? parseInt(qtyMatch[1], 10) : 1;
								return window.KaracaBxgy.addGiftForParent({
									giftVariantId: bxgyGiftMeta.giftVariantId,
									quantity: addedQty,
									parentProductId: bxgyGiftMeta.parentProductId || response.product_id,
									parentVariantId: response.variant_id || response.id,
									giftStockMeta: bxgyGiftMeta.giftStockMeta
								}).catch((err) => {
									console.warn('[BxgyGift] add gift failed', err);
								});
							}
							/* ========== BXGY GIFT END ========== */
						})
						.then(() => fetch('?section_id=helper-cart'));
				}
			})
			.then(response =>response.text())
			.then(text => {
				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
				const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
				const cartCountElement = sectionInnerHTML.querySelector('[data-cart-count]');
				const cartTotalElement = sectionInnerHTML.querySelector('[data-cart-total]');

				if(this.cartType == 'page'){
					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					if ( alert != '' ) {
						document.getElementById('AjaxCartForm').querySelector('form').prepend(alert);
					}

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
				}


				document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
					let currentCartCount = parseInt(cartCountElement.textContent, 10);
					if (freeProductAdded) {
						currentCartCount += 1;
					}
					/* ========== BXGY GIFT START ========== */
					// Gift, helper-cart fetch'inden ÖNCE (yukarıda await edilerek) eklendi;
					// cartCountElement zaten hediyeyi içeriyor. Tekrar +1 yapma.
					/* ========== BXGY GIFT END ========== */
					elm.textContent = currentCartCount;
				});
				document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
					elm.textContent = sectionInnerHTML.querySelector('[data-cart-total]').textContent;
				});
				const ajaxCartForm = document.querySelector('#AjaxCartForm');
				if (ajaxCartForm) {
					ajaxCartForm.innerHTML = cartFormInnerHTML;
				}
				
				const ajaxCartSubtotal = document.querySelector('#AjaxCartSubtotal');
				if (ajaxCartSubtotal) {
					ajaxCartSubtotal.innerHTML = cartSubtotalInnerHTML;
				}
				this.dispatchEvent(this.ADD_TO_CART);

				/* ========== BXGY GIFT START ========== */
				if (bxgyPendingShowSuccessModal) {
					bxgyPendingShowSuccessModal();
					bxgyPendingShowSuccessModal = null;
				} else {
					window.KaracaBxgy?.flushPendingWarning?.();
				}
				/* ========== BXGY GIFT END ========== */

				// a11y
				if ( document.getElementById('screen-reader-info') ) {
					document.getElementById('screen-reader-info').innerText = `${KROWN.settings.locales.cart_announcement}`;
					setTimeout(()=>{
						document.getElementById('screen-reader-info').innerText = '';
					}, 1000);
				}

			})
			.catch(e => {
				console.log(e);
			})
			.finally(() => {
				submitButtons.forEach(btn => btn.classList.remove('working'));
			});
		}

		/* ========== BXGY GIFT START ========== */
		_getBxgyGiftMeta(submitButtons) {
			const fromBtn = submitButtons && submitButtons[0];
			const fromForm = this.form && this.form.querySelector('[data-bxgy-gift-variant-id]');
			const metaSource = fromForm || fromBtn;
			const giftVariantId =
				(fromBtn && fromBtn.dataset.bxgyGiftVariantId) ||
				(fromForm && fromForm.dataset.bxgyGiftVariantId) ||
				'';
			const parentProductId =
				(fromBtn && fromBtn.dataset.bxgyParentProductId) ||
				(fromForm && fromForm.dataset.bxgyParentProductId) ||
				'';
			const giftStockMeta = window.KaracaBxgy && metaSource
				? window.KaracaBxgy.parseGiftStockMeta(metaSource)
				: null;
			return { giftVariantId, parentProductId, giftStockMeta };
		}
		/* ========== BXGY GIFT END ========== */

		showFreeProductErrorDialog() {
			const dialog = document.getElementById('freeProductErrorDialog');
			if (!dialog) {
				const baseUrl = window.location.origin + KROWN.settings.routes.root_url;
				const url = new URL(baseUrl);
				url.searchParams.set('sections', 'holly-free-product-dialog');
				fetch(url)
					.then(response => response.json())
					.then(data => {
						const tempDiv = document.createElement('div');
						tempDiv.innerHTML = data['holly-free-product-dialog'];
						document.body.appendChild(tempDiv.querySelector('dialog'));
						document.getElementById('freeProductErrorDialog').showModal();
					});
			} else {
				dialog.showModal();
			}
		}
		
		// Free Product İle Sepete Ekleme Yeni Kod
		addFreeProductToCart(variantId) {
			const formData = new FormData();
			formData.append('id', variantId);
			formData.append('quantity', 1);
		
			fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
				method: 'POST',
				headers: {
					'X-Requested-With': 'XMLHttpRequest',
				},
				body: formData,
			})
			.then(response => response.json())
			.catch(error => console.log(error));
		}

		_serializeForm(form) {
			let arr = [];
			Array.prototype.slice.call(form.elements).forEach(function(field) {
				if (
					!field.name ||
					field.disabled ||
					['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
				)
					return;
				if (field.type === 'select-multiple') {
					Array.prototype.slice.call(field.options).forEach(function(option) {
						if (!option.selected) return;
						arr.push(
							encodeURIComponent(field.name) +
								'=' +
								encodeURIComponent(option.value)
						);
					});
					return;
				}
				if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
					return;
				arr.push(
					encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
				);
			});
			return arr.join('&');
		}

	}

  if ( typeof customElements.get('product-form') == 'undefined' ) {
		customElements.define('product-form', ProductForm);
	}

}

/* ---
	Product Recommendations
--- */

if ( typeof ProductRecommendations !== 'function' ) {

	class ProductRecommendations extends HTMLElement {
		constructor() {

			super();  
      
      const SUCCESS = new Event('product-recommendations-loaded');
      const FAIL = new Event('product-recommendations-error');

      const handleIntersection = (entries, observer) => {

        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const innerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('product-recommendations');

								if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
              this.innerHTML = innerHTML.innerHTML;
              this.querySelectorAll('form').forEach(elm=>{
                if (elm.querySelector('template')) {
                  elm.append(elm.querySelector('template').content.cloneNode(true));
                }
              });
              this.dispatchEvent(SUCCESS);
            } else {
							this.dispatchEvent(FAIL);
						}
          })
          .catch(e => {
						this.dispatchEvent(FAIL);
          });
      }

			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: `0px 0px 400px 0px`}).observe(this);

		}

	}
	
  if ( typeof customElements.get('product-recommendations') == 'undefined' ) {
		customElements.define('product-recommendations', ProductRecommendations);
	}

}

/* ---
	Gift card recipent
--- */

if ( typeof GiftCardRecipient !== 'function' ) {

	class GiftCardRecipient extends HTMLElement {

		constructor() {

			super();

			const properties = Array.from(this.querySelectorAll('[name*="properties"]'));
			const checkboxPropertyName = 'properties[__shopify_send_gift_card_to_recipient]';

			this.recipientCheckbox = properties.find(input => input.name === checkboxPropertyName);
			this.recipientOtherProperties = properties.filter(input => input.name !== checkboxPropertyName);
			this.recipientFieldsContainer = this.querySelector('.gift-card-recipient__fields');

			if ( this.recipientCheckbox ) {
				this.recipientCheckbox.addEventListener('change', this.synchronizeProperties.bind(this));
			}
			this.synchronizeProperties();

		}

		synchronizeProperties() {
			this.recipientOtherProperties.forEach(property => property.disabled = !this.recipientCheckbox.checked);
			this.recipientFieldsContainer.classList.toggle('hide', !this.recipientCheckbox.checked);
		}

	}

  if ( typeof customElements.get('gift-card-recipient') == 'undefined' ) {
		customElements.define('gift-card-recipient', GiftCardRecipient);
	}

}